import React from 'react'
import Button from '../../atoms/Button/Button'
import { ArrowRight } from '../../atoms/NewIcons'
import Link from 'next/link'
import MyImage from '../../atoms/MyImage/MyImage'
import useTrans from '../../../hooks/useTrans'
import { getAltText } from '../../../utils/safe'

const HomepageServiceCard = ({ servizi, url }) => {
  const t = useTrans()
  return (
    <div className="homepage-service">
      <div className="homepage-service__card-container">
        {servizi.map((obj, k) => {
          return (
            <div className="homepage-service__card" key={k}>
              <div className="homepage-service__card__icon">
                {obj.image && (
                  <MyImage src={obj.image.url} width={80} height={80} alt={getAltText(obj.image)} />
                )}
              </div>
              <h3 className="homepage-service__card__title">{obj.name}</h3>
              <p className="homepage-service__card__description">{obj.description}</p>
            </div>
          )
        })}
      </div>
      {!!url && (
        <Button
          href={url}
          label={t('Esplora i nostri servizi')}
          icon={<ArrowRight />}
          size="large"
          responsive={true}
          variant="ghost"
          className="homepage-service__cta"
          next
        />
      )}
    </div>
  )
}

export default HomepageServiceCard
